import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Profile from './components/Profile';

const ProfilePage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Profile</h3>
      </Col>
    </Row>
    <Row>
      <Profile />
    </Row>
  </Container>
);

export default ProfilePage;
